import { getTimezoneOffset } from 'date-fns-tz';

export const guessCurrentTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getTimeZone = (tz?: string | true): string | undefined => {
  return tz === true ? guessCurrentTimeZone() : tz;
};

/**
 *
 * @param { String } tzName
 * @param { Date } timeStamp
 * @returns the offset in milliseconds between the time zone and UTC time.
 */
export const getTimeZoneOffsetValue = (tzName: string, timeStamp?: Date): number => {
  return getTimezoneOffset(tzName, timeStamp ?? new Date());
};

export const getAllTimeZones = () => Intl.supportedValuesOf('timeZone');
